import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CardPaymentService = {
  cardTxns: async ({
    CardUid = "",
    userId,
    type,
    status,
    from,
    to,
    pageNumber,
    pageSize,
  }) => {
    const params = new URLSearchParams({
      ...(CardUid && { CardUid: CardUid.toString() }),
      ...(userId && { userId: userId.toString() }),
      ...(type && { type: type.toString() }),
      ...(status && { status: status.toString() }),
      ...(from && { from: from.toString() }),
      ...(to && { to: to.toString() }),
      ...(pageNumber && { pageNumber: pageNumber.toString() }),
      ...(pageSize && { pageSize: pageSize.toString() }),
    });
    const response = await apiService.get(
      `/card-payment/transactions?${params.toString()}`,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      },
    );
    return response.data;
  },
  recharge: async (data) => {
    const response = await apiService.post(
      `/card-payment/wallets/recharge`,
      data,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      },
    );
    return response.data;
  },
  assignCard: async (data) => {
    const response = await apiService.post(`/card-payment/cards`, data, {
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
  voidPayment: async (id, data) => {
    const response = await apiService.post(
      `/card-payment/transactions/${id}/void`,
      data,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      },
    );
    return response.data;
  },
  status: async (id, data) => {
    const response = await apiService.patch(
      `/card-payment/cards/${id}/status`,
      data,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      },
    );
    return response.data;
  },
  getCardDetail: async (id) => {
    const response = await apiService.get(`/card-payment/balance/${id}`, {
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
};

export default CardPaymentService;
